export const SUBSCRIBE_MESSAGE = 'e:topHashChangeEvent:subscribe';
export const UNSUBSCRIBE_MESSAGE = 'e:topHashChangeEvent:unsubscribe';
export const HASH_CHANGE_MESSAGE = 'e:topHashChangeEvent:hashChange';
